import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Box } from '../Box/Box.js';
import styled from 'styled-components';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FloatingButtonGroupStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "FloatingButtonGroupstyled__FloatingButtonGroupStyled",
  componentId: "sc-etfdr8-0"
})(function (props) {
  var isRTL = props.$isRTL;
  var firstChildStyle = {
    borderTopLeftRadius: isRTL ? '0' : undefined,
    borderBottomLeftRadius: isRTL ? '0' : undefined,
    borderTopRightRadius: isRTL ? undefined : '0',
    borderBottomRightRadius: isRTL ? undefined : '0'
  };
  var middleChildStyle = {
    borderRadius: '0'
  };
  var lastChildStyle = {
    borderTopLeftRadius: isRTL ? undefined : '0',
    borderBottomLeftRadius: isRTL ? undefined : '0',
    borderTopRightRadius: isRTL ? '0' : undefined,
    borderBottomRightRadius: isRTL ? '0' : undefined
  };
  var buttonBorderStyles = {
    '&[data-drone-index="0"]': firstChildStyle,
    '&[data-drone-index="1"]': props.$count === 2 ? lastChildStyle : middleChildStyle,
    '&[data-drone-index="2"]': lastChildStyle
  };
  return {
    display: 'inline-flex',
    'button, button.box': _objectSpread({
      borderWidth: '0',
      borderStyle: 'none',
      boxShadow: 'none',
      margin: '0'
    }, buttonBorderStyles)
  };
});

export { FloatingButtonGroupStyled };
//# sourceMappingURL=FloatingButtonGroup.styled.js.map
